// @flow
// $FlowFixMe
import { createContext } from 'react';

const DimensionContext = createContext<{[x: string]: number}>({
  default: 1,
  lg: 1,
  md: 1,
  sm: 1,
  xl: 1,
});

export default DimensionContext;
